import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { REMOVE_ARTICLE } from "../article.queries";
import {
  RemoveArticleMutation,
  RemoveArticleMutationVariables,
} from "../../../__generated__/RemoveArticleMutation";

export const useRemoveArticle = () => {
  return useMutation<RemoveArticleMutation, RemoveArticleMutationVariables>(REMOVE_ARTICLE, {
    refetchQueries: ["ArticlesQuery"],
    update(cache) {
      evictFields(cache, ["article", "articles"]);
    },
  });
};
